// import React from "react";
// import logo from "../assets/reelz.jpg"; 

// function Navbar() {
//   return (
//     <nav className="navbar">
//       <div className="logo">
//         <img src={logo} alt="ReelOnGo Logo" />
//       </div>

//       <ul className="nav-links">
//         <li>Pricing</li>
//         <li>Services</li>
//         <li>Process</li>
//         <li>Testimonials</li>
//       </ul>

//       <button className="book-now">Book Now</button>
//     </nav>
//   );
// }

// export default Navbar;



import React, { useState } from "react";
import logo from "../assets/reelzz.png";


function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="navbar">
      <div className="logo">
        <img src={logo} alt="logo" />
      </div>

      {/* Hamburger Menu */}
      <div
        className={`menu-icon ${isOpen ? "active" : ""}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className="bar"></span>
        <span className="bar"></span>
        <span className="bar"></span>
      </div>

      {/* Nav Links */}
      <ul className={`nav-links ${isOpen ? "open" : ""}`}>
        <li>Pricing</li>
        <li>Services</li>
        <li>Process</li>
        <li>Testimonials</li>
      </ul>

      <button className="book-now">Book Now</button>
    </nav>
  );
}

export default Navbar;
